var OKM_PF = {
  storage: {
    email: '',
    language: '',
    domain: '',
    sent: '',
    questions: [],
    detectors: []
  },
  init: function(){
    this.readStorage();
  },
  clearStorage: function(){
    this.storage.email = '';
    this.storage.phone = '';
    this.storage.language = '';
    this.storage.domain = '';
    this.storage.sent = '';
    this.storage.questions = [];
    this.storage.detectors = [];
    this.writeStorage();
  },
  readStorage: function(){
    if ( localStorage && localStorage.getItem( "okm-detector-finder" ) ){
      this.storage = JSON.parse( localStorage.getItem( "okm-detector-finder" ) );
    }
  },
  writeStorage: function(){
    if ( localStorage && this.storage ){
      localStorage.setItem( "okm-detector-finder", JSON.stringify( this.storage ) );
    }
  },
  addQuestion: function(question,answer){
    let obj = new Object();
    obj.question = question;
    obj.answer = answer;

    let found = false;
    this.storage.questions.forEach( (item) => {
      if ( item.question === question ) {
        found = true;
        item.answer = answer;
      }
    });
    
    if ( found == false ) this.storage.questions.push( obj );
    this.writeStorage();
  },
  addPoints: function(id,points,data){
    let found = false;
    let obj = null;
    this.storage.detectors.forEach( (item) => {
      if ( item.id === id ) {
        found = true;
        obj = item;
      }
    });

    if ( found == false ){
      let obj = new Object();
      obj.id = id;
      obj.points = points;
      obj.data = data;
    
      this.storage.detectors.push( obj );
    }
    else
      obj.points += points;
   
    this.writeStorage();
  },
  addDetectors: function(detectors){
    this.storage.detectors = detectors;
    this.writeStorage();
  },
  addContact: function(email,phone){
    this.storage.email = email;
    this.storage.phone = phone;
    this.writeStorage();
  },
  addLanguage: function(lang){
    this.storage.language = lang;
    this.writeStorage();
  },
  addDomain: function(domain){
    this.storage.domain = domain;
    this.writeStorage();
  },
  setSent : function()
  {
    this.storage.sent = 'true';
    this.writeStorage();
  }
}